/**
 * Utility for storing and retrieving recently used tasks per user
 * Uses localStorage with a max of 20 items per user
 */

const STORAGE_KEY = "tolkn_recent_tasks";
const MAX_ITEMS = 20;

export function getRecentTasks(userId) {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return [];
    const parsed = JSON.parse(data);
    return parsed[userId] || [];
  } catch (e) {
    console.error("Error reading recent tasks:", e);
    return [];
  }
}

export function addRecentTask(userId, taskItem) {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    const parsed = data ? JSON.parse(data) : {};
    const userTasks = parsed[userId] || [];
    
    // Remove duplicate if exists
    const filtered = userTasks.filter(t => 
      !(t.taskId === taskItem.taskId && t.subtaskId === taskItem.subtaskId && t.bundleId === taskItem.bundleId)
    );
    
    // Add to front
    filtered.unshift({
      ...taskItem,
      usedAt: Date.now(),
    });
    
    // Keep only MAX_ITEMS
    parsed[userId] = filtered.slice(0, MAX_ITEMS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
  } catch (e) {
    console.error("Error saving recent task:", e);
  }
}

export function clearRecentTasks(userId) {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const parsed = JSON.parse(data);
    delete parsed[userId];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
  } catch (e) {
    console.error("Error clearing recent tasks:", e);
  }
}
